import { queryOptions } from "@tanstack/react-query";
import { listAds } from "@/lib/ads.functions";

export type HomeSellerFilter = "alla" | "private" | "business";

/** Senaste annonserna på startsidan – delas av route-loadern och rutnätet. */
export const latestAdsQueryOptions = (
  country: "SE" | "ES" = "SE",
  seller: HomeSellerFilter = "alla",
) =>
  queryOptions({
    queryKey: ["ads", "latest", 12, country, seller],
    queryFn: () =>
      listAds({
        data: { limit: 12, country, sellerType: seller === "alla" ? undefined : seller },
      }),
  });
